//
//
//
//

export default {
  data: function data() {
    return {};
  },
  created: function created() {
    this.postLogin();
  },
  methods: {
    postLogin: function postLogin() {
      var self = this;
      Lib.M.ajax({
        'method': "POST",
        'url': 'third/eam/login?token=' + self.$route.query.u + '&c=' + self.$route.query.c,
        'params': {},
        'headers': {
          appId: 'KS4PEszy',
          appSecret: '9684e632912b54c40c8ba84efbae97112a5dc4f3'
        },
        'success': function success(data) {
          sessionStorage.setItem("data", JSON.stringify(data.obj.user));
          sessionStorage.setItem("token", JSON.stringify(data.obj.token));
          localStorage.setItem("token", JSON.stringify(data.obj.token));
          sessionStorage.setItem("menu", JSON.stringify(data.obj.menu));
          sessionStorage.setItem("permission", JSON.stringify(data.obj.permission));
          self.$store.dispatch("dispatchIsLogin", 1);
          self.$router.push("/main/portal");
        }
      });
    }
  }
};